// BL-2553 — the phone header row's height, owned once. The brand bar, the nav drawer's header
// and the drill-down Back rows (BL-2554) all sit on this row, so titles line up across screens.

/** 56px: the phone shell's header row. The desktop rail keeps its own 64px header. */
export const SHELL_ROW_HEIGHT = 'h-14';
